import { Phone } from "lucide-react";
import { SHOP, waLink } from "@/lib/shop";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const MobileBar = () => (
  <div className="fixed bottom-0 inset-x-0 z-40 md:hidden p-3 bg-white/90 backdrop-blur-lg border-t border-slate-200 shadow-[0_-10px_40px_rgba(0,0,0,0.06)] grid grid-cols-2 gap-2" data-testid="mobile-contact-bar">
    <a href={`tel:${SHOP.phoneTel}`} className="inline-flex items-center justify-center gap-2 rounded-full bg-ink py-3.5 font-bold text-white" data-testid="mobile-call-btn"><Phone className="h-5 w-5" /> Call</a>
    <a href={waLink("Hi FONZ FIX4U, I have a question.")} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] py-3.5 font-bold text-white" data-testid="mobile-whatsapp-btn"><WhatsAppIcon /> WhatsApp</a>
  </div>
);
